import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "@/i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import NewsDetail from "@/pages/NewsDetail";
import Marketplace from "@/pages/Marketplace";
import ApiDocs from "@/pages/ApiDocs";
import Search from "@/pages/Search";
import Legal from "@/pages/Legal";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Admin from "@/pages/Admin";
import ControlCenter from "@/pages/ControlCenter";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Changelog from "@/pages/Changelog";
import Status from "@/pages/Status";
import Careers from "@/pages/Careers";
import Faq from "@/pages/Faq";

function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-black text-neutral-100">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/news/:id" element={<NewsDetail />} />
              <Route path="/marketplace" element={<Marketplace />} />
              <Route path="/marketplace/docs" element={<ApiDocs />} />
              <Route path="/docs" element={<Navigate to="/marketplace/docs" replace />} />
              <Route path="/pricing" element={<Marketplace />} />
              <Route path="/terms" element={<Legal type="terms" />} />
              <Route path="/privacy" element={<Legal type="privacy" />} />
              <Route path="/refund" element={<Legal type="refund" />} />
              <Route path="/search" element={<Search />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/control-center" element={<ControlCenter />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/changelog" element={<Changelog />} />
              <Route path="/status" element={<Status />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/faq" element={<Faq />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}
